import { NotificationType } from '../../notification/types/notification.types';

export type NotificationBody = {
  title: string;
  message: string;
};

export type NotificationQuerySelector = {
  allUsers: boolean;
};

export enum NotificationStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}

export interface ViewNotificationContent {
  id: number;
  body: NotificationBody;
  expiryDate: string | null;
  querySelector: NotificationQuerySelector;
  status: NotificationStatus;
  type: NotificationType;
  datetimeDeleted: string | null;
  datetimeAdded: string | null;
  datetimeModified: string | null;
}

export enum NotificationState {
  Read = 'read',
  Seen = 'seen',
}

export interface ViewNotificationReceipt {
  id: number;
  expiryDate?: string;
  state: NotificationState | null;
  content: Pick<ViewNotificationContent, 'id' | 'body' | 'type'> & { datetimePublished?: string };
}
